/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'RESPONSIBLE_PERSON_S_HAVE_BEEN_DEFINED_AND_ARE_ACCOUNTABLE_FOR_WRITTEN',
              'RESPONSIBLE_PERSON_S_HAVE_BEEN_DEFINED_AND_ARE_ACCOUNTABLE_FOR_',
              'THE_FACILITY_HAS_NOT_DEFINED_RESPONSIBLE_PERSON_S_',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    has_the_fac_defined_the_persons_responsible_for_the_implementat: valueSchema,
  },
}
